import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
    selector: 'border-crossing',
    template: `
    <button
      [hidden]="isBtnvisible"
      class="border"
      style="cursor: pointer; margin-top:1px"
      (click)="btnClick($event)"
    >
      <i
        class="fa-solid fa-circle-info"
        style="color: #2b7af4"
        title="Border Crossing"
      ></i>
    </button>
  `,
    styles: [
        `
      .border {
        border: 1px solid #d7dce1;
        background: transparent
          linear-gradient(180deg, #ffffff 0%, #e9f0f3 100%) 0% 0% no-repeat
          padding-box;
        opacity: 1;
        font-weight: 500;
        color: #000000;
        font-size: 20px;
        border-radius: 2px;
        width: 34px;
      }
    `,
    ],
    standalone: false // NOSONAR
})
export class BorderCrossing implements ICellRendererAngularComp {
  params: any;
  isBtnvisible: boolean = false;
  refresh(): boolean {
    return false;
  }
  agInit(params: any): void {
    this.params = params;
    if (params.data.border == 0 || params.data.border == null) {                      // NOSONAR
      this.isBtnvisible = true;
    } else {
      this.isBtnvisible = false;
    }
  }
  btnClick(event: MouseEvent) {
    event.stopPropagation();
    this.params?.context.componentParent.openBorderCrossing(
      this.params.data.route_id,
      this.params.data.main_route,
      this.params.data.unload_start
    );
  }
}
